import React from "react";
import TextField from "@mui/material/TextField";
import Typeahead from "@mui/material/Autocomplete";

export const Autocomplete = ({
  options,
  label,
  size = "small",
  renderOption = null,
  loading,
  value,
  multiple,
  autoCompleteValue = null,
  disabled,
  onSelection = () => {},
  disableCloseOnSelect,
  ...textFieldProps
}) => {
  return (
    <>
      {multiple ? (
        <Typeahead
          disablePortal
          options={options}
          disabled={disabled}
          className="tma_auto_complete"
          size={size}
          disableCloseOnSelect={disableCloseOnSelect ? true : false}
          renderOption={renderOption}
          loading={loading}
          value={autoCompleteValue}
          // filterOptions={(options) => {
          //   return [{ label: "Select All", all: true }, ...options];
          // }}
          onChange={(e, value) => {
            onSelection(value);
          }}
          onInputChange={(e, inputValue, reason) => {
            if (reason === "clear" || inputValue === "") {
              onSelection(null);
            }
          }}
          autoScrollToSelectedOption={false}
          clearOnEscape={true}
          renderInput={(params) => (
            <TextField {...params} label={label} {...textFieldProps} />
          )}
          ListboxProps={{
            disableScrollIntoView: true,
          }}
        />
      ) : (
        <Typeahead
          disablePortal
          options={options}
          disabled={disabled}
          className="tma_auto_complete"
          size={size}
          disableCloseOnSelect={disableCloseOnSelect ? true : false}
          renderOption={renderOption}
          loading={loading}
          value={autoCompleteValue}
          filterOptions={(options) => options}
          onChange={(e, value) => {
            onSelection(value);
          }}
          onInputChange={(e, inputValue, reason) => {
            if (reason === "clear" || inputValue === "") {
              onSelection(null);
            }
          }}
          clearOnEscape={true}
          renderInput={(params) => (
            <TextField {...params} label={label} {...textFieldProps} />
          )}
        />
      )}
    </>
  );
};
